export const enum ProviderType {
    CM = "cm",
    TWILIO = "twilio",
    TEST = "test",
    FACEBOOK = "facebook",
    SMOOCH = "smooch",
    SAYSIMPLE = "saysimple",
    EAZY = "eazy",
    MESSAGEBIRD = "messagebird",
    BCONNECT = "bconnect",
    TWITTER = "twitter",
    SPRYNG = "spryng",
    WHATSAPP = "whatsapp",
    BIRD = "bird",
}
